import { defineMessages } from 'react-intl';

export default defineMessages({
  splitSizeAlert: {
    id: 'selector.group.splitSizeAlertTitle',
    defaultMessage: 'Your product is large, exceeding the width of {width}{widthUnit} and height of {height}{heightUnit}, and will be split up.',
  },
  noQuantity: {
    id: 'selector.grid.noquantity',
    defaultMessage: 'Please fill in the quantity per size and hit the confirm button',
  },
  'number-of-sheets': {
    id: 'selector.attribute.numberOfSheets',
    defaultMessage: '{value} Pages',
  },
  groupedquantity: {
    id: 'selector.quantity.suffix',
    defaultMessage: '{value} pieces',
  },
});
